import Vue from 'vue'

import App from './App.vue'
import vuetify from './plugins/vuetify'
import vueAxios from './plugins/vueAxios'
import vueRouter from './plugins/vueRouter'
import store from './store'
import router from './router'
import interceptorsSetup from './helpers/interceptors'
import * as VueGoogleMaps from 'vue2-google-maps'
import './assets/css/style.styl'

const ImageZoom = require('vue-image-zoomer').default

Vue.config.productionTip = false
Vue.component('image-zoom', ImageZoom)

// and running it somewhere here
interceptorsSetup()

// console.log(
//   ' process.env.VUE_APP_GOOGLE_MAP_API_KEY',
//   process.env.VUE_APP_GOOGLE_MAP_API_KEY,
// )

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAP_API_KEY,
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true,
})

new Vue({
  store,
  vuetify,
  vueAxios,
  vueRouter,
  router,
  render: (h) => h(App),
}).$mount('#app')
